import { useDispatch, useSelector } from 'react-redux'
import { updateGeneralSummaryReport } from '@/redux/actions/generalsummaryreport'
import { IRootState } from '@/redux/types'

const useGeneralSummaryReport = (menuId: number) => {
  const dispatch = useDispatch()
  const { isAuth } = useSelector((state: IRootState) => state.auth)

  const handleClickGeneralSummaryReport = (foreignId: number) => {
    if (isAuth) {
      const data = [{ menu_id: menuId, foreign_id: foreignId }]
      dispatch(updateGeneralSummaryReport({ data, action: 'times_clicked' }))
    }
  }

  const handleViewGeneralSummaryReport = (foreignId: number) => {
    if (isAuth) {
      const data = [{ menu_id: menuId, foreign_id: foreignId }]
      dispatch(updateGeneralSummaryReport({ data, action: 'times_viewed' }))
    }
  }

  return { handleClickGeneralSummaryReport, handleViewGeneralSummaryReport }
}

export default useGeneralSummaryReport
